function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from "react";
import "./dashboard.css";
import { Chart } from "react-google-charts";
import moment from "moment-timezone";
import { MdInfo } from "react-icons/md";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
export var options = {
  vAxis: {
    title: "Members Count",
    minValue: 0
  },
  seriesType: "bars",
  // series: { 5: { type: "line" } },
  legend: {
    position: "bottom",
    top: "10%"
  },
  tooltip: {
    isHtml: true,
    trigger: "visible"
  },
  colors: ["#F1C40F", "#2ECC71", "#E67E22"]
};
var WorkLoadAnalysisData = function WorkLoadAnalysisData(props) {
  var workLoadAnalysis = props.workLoadAnalysis;
  var workLoadAnalysisChartData = workLoadAnalysis ? workLoadAnalysis.workLoadChartData.reduce(function (acc, curr) {
    var date = curr.date,
      overWorkedCount = curr.overWorkedCount,
      healthyCount = curr.healthyCount,
      lessUtilisedCount = curr.lessUtilisedCount;
    var chartDate = moment(date).format("DD MMM, YYYY");
    return [].concat(_toConsumableArray(acc), [[chartDate, Number(overWorkedCount), "color:#F1C40F", "<div class=\"apps-tootlip\">\n              <span class=\"apps-tootlip-time\">Over Worked</span>\n              <br>\n              <span class=\"apps-tootlip apps-tootlip-title \">Members Count: ".concat(overWorkedCount, "</span>\n              <br>\n              <span class=\"apps-tootlip apps-tootlip-title\">Worked more than ").concat(workLoadAnalysis === null || workLoadAnalysis === void 0 ? void 0 : workLoadAnalysis.overWorkedHours, "</span>\n          </div>"), Number(healthyCount), "color:#2ECC71", "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-time\">Healthy</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Members Count: ".concat(healthyCount, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Worked between ").concat(workLoadAnalysis === null || workLoadAnalysis === void 0 ? void 0 : workLoadAnalysis.lessUtilisedWorkedHours, " to ").concat(workLoadAnalysis === null || workLoadAnalysis === void 0 ? void 0 : workLoadAnalysis.overWorkedHours, "</span>\n          </div>"), Number(lessUtilisedCount), "color:#E67E22", "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-time\">Less Utilised</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Members Count: ".concat(lessUtilisedCount, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Worked less than ").concat(workLoadAnalysis === null || workLoadAnalysis === void 0 ? void 0 : workLoadAnalysis.lessUtilisedWorkedHours, "</span>\n          </div>")]]);
  }, [["Month", "Over Worked", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "Healthy", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "Less Utilised", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]) : [["Month", "Over Worked", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "Healthy", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "Less Utilised", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]];
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-website-list"
  }, "Work Load Analysis", /*#__PURE__*/React.createElement(OverlayTrigger, {
    key: "currently-working",
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "count-tooltip-whole"
    }, "Work load analysis is calculated based on your Work Time Settings in the Track Settings page."))
  }, /*#__PURE__*/React.createElement(MdInfo, {
    className: "work-load-analysis-head-title-con"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-member-chart-section-top"
  }, /*#__PURE__*/React.createElement(Chart, {
    chartType: "ComboChart",
    width: "100%",
    height: "100%",
    loader: /*#__PURE__*/React.createElement("div", null, "Loading"),
    data: workLoadAnalysisChartData,
    options: options
  })));
};
export default WorkLoadAnalysisData;